import * as React from 'react'

import { cn } from '@/lib/utils'

interface CheckboxProps extends Omit<React.ComponentProps<'input'>, 'type'> {
  onCheckedChange?: (checked: boolean) => void
}

function Checkbox({ className, onCheckedChange, onChange, ...props }: CheckboxProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e)
    onCheckedChange?.(e.target.checked)
  }

  return (
    <input
      type="checkbox"
      data-slot="checkbox"
      className={cn(
        'border-input bg-background h-4 w-4 shrink-0 rounded border shadow-xs transition-colors',
        'checked:bg-primary checked:border-primary checked:text-primary-foreground',
        'focus-visible:ring-ring focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      onChange={handleChange}
      {...props}
    />
  )
}

export { Checkbox }
